import React, { AriaRole } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface LazyImgixImageProps {
  alt?: string;
  className?: string;
  role?: AriaRole;
  src: string;
  sizes?: string;
  wrapperClassName?: string;
}

const LazyImgixImage = ({
  alt,
  className,
  role,
  src,
  sizes,
  wrapperClassName,
}: LazyImgixImageProps) => {
  const isGif = src.endsWith('.gif');
  const imageSrc = `${src}?auto=compress&fit=crop&${isGif ? 'gif-q=50' : 'auto=format'}`;
  const placeholderSrc = `${src}?auto=compress,format&fit=crop&w=800&blur=200`;
  const srcSet = `${imageSrc}&w=400&dpr=0.75 300w,
    ${imageSrc}&w=400&dpr=1 400w,
    ${imageSrc}&w=400&dpr=1.5 600w,
    ${imageSrc}&w=400&dpr=2 800w,
    ${imageSrc}&w=400&dpr=2.5 1000w,
    ${imageSrc}&w=400&dpr=3 1200w,
    ${imageSrc}&w=400&dpr=3.5 1400w,
    ${imageSrc}&w=400&dpr=4 1600w,
    ${imageSrc}&w=400&dpr=4.5 1800w`;

  return (
    <LazyLoadImage
      alt={alt}
      loading="lazy"
      className={className}
      wrapperClassName={wrapperClassName}
      role={role}
      src={imageSrc}
      srcSet={srcSet}
      sizes={sizes}
      placeholderSrc={placeholderSrc}
    />
  );
};

export default LazyImgixImage;
